import { createContext } from 'react';
import { IGetDishInfoV2, IItemForGetShortInfo, IItemForGetShortDishInfo } from 'types';

export interface IModificationsModalState {
	dishInfo: Nullable<IGetDishInfoV2['data']>;
	IDsSelectedRestaurant: string[];
	selectedModificationsDishCategory: Nullable<string>;
	selectedModificationsDishSubCategory: Nullable<string>;
	selectedModificationsDishes: string[];
	fetchedModificationsDishes: IItemForGetShortDishInfo[];
}

export const modificationsModalInitialState: IModificationsModalState = {
	dishInfo: null,
	IDsSelectedRestaurant: [],
	selectedModificationsDishCategory: null,
	selectedModificationsDishSubCategory: null,
	fetchedModificationsDishes: [],
	selectedModificationsDishes: [],
};

export interface IModificationsModalContext extends IModificationsModalState {
	setModificationsDishCategory(value: Nullable<string>): void;
	setModificationsDishSubCategory(value: Nullable<string>): void;
	setFetchedModificationsDishes(value: IItemForGetShortInfo[]): void;
	setModificationsDishes(value: string[]): void;
	removeModificationsDish(value: string): void;
}

export const ModificationsModalContext = createContext<IModificationsModalContext>({
	setModificationsDishCategory: () => undefined,
	setModificationsDishSubCategory: () => undefined,
	setFetchedModificationsDishes: () => undefined,
	setModificationsDishes: () => undefined,
	removeModificationsDish: () => undefined,
	...modificationsModalInitialState,
});
